export default __webpack_public_path__ + "static/media/Tecnologia_diseno_tvs_ntorq_125.e833bd3a.jpg";